import AxiosConfig from '../utils/AxiosConfig';

class CampaignService {
  // ============================================
  // Welcome Campaign (Campaña de Bienvenida)
  // ============================================

  /**
   * Obtener configuración de campaña de bienvenida
   * GET /marketing/campaigns/welcome
   */
  async getWelcomeCampaign() {
    try {
      console.log('[CampaignService] GET /marketing/campaigns/welcome - Request');
      const response = await AxiosConfig.get('/marketing/campaigns/welcome');
      console.log('[CampaignService] GET /marketing/campaigns/welcome - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[CampaignService] GET /marketing/campaigns/welcome - Error:', error);
      console.error('[CampaignService] GET /marketing/campaigns/welcome - Error Response:', error.response?.data);
      throw error;
    }
  }

  /**
   * Crear o actualizar campaña de bienvenida
   * POST /marketing/campaigns/welcome
   */
  async saveWelcomeCampaign(campaignData) {
    try {
      console.log('[CampaignService] POST /marketing/campaigns/welcome - Request:', campaignData);
      const response = await AxiosConfig.post('/marketing/campaigns/welcome', campaignData);
      console.log('[CampaignService] POST /marketing/campaigns/welcome - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[CampaignService] POST /marketing/campaigns/welcome - Error:', error);
      console.error('[CampaignService] POST /marketing/campaigns/welcome - Error Response:', error.response?.data);
      throw error;
    }
  }

  /**
   * Actualizar campaña de bienvenida
   * PUT /marketing/campaigns/welcome
   */
  async updateWelcomeCampaign(campaignData) {
    try {
      const response = await AxiosConfig.put('/marketing/campaigns/welcome', campaignData);
      return response.data;
    } catch (error) {
      console.error('[CampaignService] PUT /marketing/campaigns/welcome - Error:', error);
      throw error;
    }
  }

  // ============================================
  // Loyalty Card Campaign (Campaña Tipo Cartilla)
  // ============================================

  /**
   * Obtener configuración de campaña tipo cartilla
   * GET /marketing/campaigns/loyalty-card
   */
  async getLoyaltyCardCampaign() {
    try {
      console.log('[CampaignService] GET /marketing/campaigns/loyalty-card - Request');
      // Se llama de forma ambiental desde Clients.jsx (core, no gateado por
      // plugin) para mostrar el widget de cartilla — si la empresa tiene el
      // plugin de Marketing apagado, esto debe fallar en silencio, no tirar
      // a toda la app a permission-denied.
      const response = await AxiosConfig.get('/marketing/campaigns/loyalty-card', {
        skipGlobalErrorRedirect: true
      });
      console.log('[CampaignService] GET /marketing/campaigns/loyalty-card - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[CampaignService] GET /marketing/campaigns/loyalty-card - Error:', error);
      console.error('[CampaignService] GET /marketing/campaigns/loyalty-card - Error Response:', error.response?.data);
      throw error;
    }
  }

  /**
   * Obtener URL presignada de la imagen del sello completado (para preview en dashboard)
   * GET /marketing/campaigns/loyalty-card/stamp-image-url
   */
  async getLoyaltyCardStampImageUrl() {
    try {
      const response = await AxiosConfig.get('/marketing/campaigns/loyalty-card/stamp-image-url');
      const body = response.data?.data ?? response.data;
      return body?.url ?? '';
    } catch (error) {
      console.error('[CampaignService] GET stamp-image-url - Error:', error);
      return '';
    }
  }

  /**
   * Crear o actualizar campaña tipo cartilla
   * POST /marketing/campaigns/loyalty-card
   */
  async saveLoyaltyCardCampaign(campaignData) {
    try {
      console.log('[CampaignService] POST /marketing/campaigns/loyalty-card - Request:', campaignData);
      const response = await AxiosConfig.post('/marketing/campaigns/loyalty-card', campaignData);
      console.log('[CampaignService] POST /marketing/campaigns/loyalty-card - Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[CampaignService] POST /marketing/campaigns/loyalty-card - Error:', error);
      console.error('[CampaignService] POST /marketing/campaigns/loyalty-card - Error Response:', error.response?.data);
      throw error;
    }
  }

  /**
   * Actualizar campaña tipo cartilla
   * PUT /marketing/campaigns/loyalty-card
   */
  async updateLoyaltyCardCampaign(campaignData) {
    try {
      const response = await AxiosConfig.put('/marketing/campaigns/loyalty-card', campaignData);
      return response.data;
    } catch (error) {
      console.error('[CampaignService] PUT /marketing/campaigns/loyalty-card - Error:', error);
      throw error;
    }
  }

  // ============================================
  // Tracking de Campaña Tipo Cartilla
  // ============================================

  /**
   * Obtener estado de tracking de un cliente
   * GET /marketing/campaigns/loyalty-card/tracking?clientId={clientId}
   */
  async getClientTracking(clientId) {
    try {
      const response = await AxiosConfig.get('/marketing/campaigns/loyalty-card/tracking', {
        params: { clientId }
      });
      return response.data;
    } catch (error) {
      console.error('[CampaignService] GET /marketing/campaigns/loyalty-card/tracking - Error:', error);
      throw error;
    }
  }

  /**
   * Obtener historial de tracking de un cliente
   * GET /marketing/campaigns/loyalty-card/tracking/history?clientId={clientId}&limit={limit}
   */
  async getClientTrackingHistory(clientId, limit = 50) {
    try {
      const response = await AxiosConfig.get('/marketing/campaigns/loyalty-card/tracking/history', {
        params: { clientId, limit }
      });
      return response.data;
    } catch (error) {
      console.error('[CampaignService] GET /marketing/campaigns/loyalty-card/tracking/history - Error:', error);
      throw error;
    }
  }

  /**
   * Reclamar recompensa
   * POST /marketing/campaigns/loyalty-card/tracking/claim?clientId={clientId}
   */
  async claimReward(clientId) {
    try {
      const response = await AxiosConfig.post('/marketing/campaigns/loyalty-card/tracking/claim', null, {
        params: { clientId }
      });
      return response.data;
    } catch (error) {
      console.error('[CampaignService] POST /marketing/campaigns/loyalty-card/tracking/claim - Error:', error);
      throw error;
    }
  }

  async getPostSaleCampaigns() {
    const response = await AxiosConfig.get('/marketing/campaigns/post-sale');
    return response.data?.data ?? response.data ?? [];
  }

  async savePostSaleCampaign(campaignData, id = null) {
    const response = id
      ? await AxiosConfig.put(`/marketing/campaigns/post-sale/${id}`, campaignData)
      : await AxiosConfig.post('/marketing/campaigns/post-sale', campaignData);
    return response.data?.data ?? response.data;
  }

  async deletePostSaleCampaign(id) {
    const response = await AxiosConfig.delete(`/marketing/campaigns/post-sale/${id}`);
    return response.data?.data ?? response.data;
  }

  async getPedidosYaCampaign() {
    const response = await AxiosConfig.get('/marketing/campaigns/pedidos-ya');
    return response.data?.data ?? response.data ?? null;
  }

  async savePedidosYaCampaign(campaignData) {
    const response = await AxiosConfig.put('/marketing/campaigns/pedidos-ya', campaignData);
    return response.data?.data ?? response.data;
  }
}

export default new CampaignService();
